export default __webpack_public_path__ + "static/media/svg-4.b568eb25.svg";